import {
  createFindingMention,
  type ChatMentionsMenuItemType,
  type InternalEnrichedFinding,
} from '@terra/ui-design-system';

export function resolveSelectedFindings({
  selectedIds,
  findings,
}: {
  selectedIds: readonly string[];
  findings: readonly InternalEnrichedFinding[];
}): InternalEnrichedFinding[] {
  const findingsById = new Map(
    findings.map((finding) => [finding.id, finding]),
  );

  return selectedIds.flatMap((id) => {
    const finding = findingsById.get(id);

    return finding ? [finding] : [];
  });
}

export function sendFindingsToCreateChainCopilot({
  findings,
  prompt,
  addMention,
  appendPrompt,
}: {
  findings: readonly InternalEnrichedFinding[];
  prompt: string;
  addMention: (mention: ChatMentionsMenuItemType) => void;
  appendPrompt: (text: string) => void;
}): void {
  for (const finding of findings) {
    addMention(createFindingMention(finding));
  }

  appendPrompt(prompt);
}
